import axios, { AxiosRequestConfig } from 'axios';
import { WarehouseSnapshot } from '../models/NV04';
import CSharpUtils from './CSharpUtils';
import Utils from './Utils';

export const fetchWarehouseSnapshot = (
  companyId: number,
  selectedYear?: number,
  selectedMonth?: number
) => {
  const params: Record<string, any> = {
    CompanyId: companyId,
  };

  if (selectedYear !== undefined) {
    params.SelectedYear = selectedYear;
  }
  if (selectedMonth !== undefined) {
    params.SelectedMonth = String(selectedMonth).padStart(2, '0');
  }

  const config: AxiosRequestConfig = {
    method: 'get',
    url: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/warehouse/warehousevalue`,
    params,
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    responseType: 'json',
    timeout: 10000,
  };

  return axios.request<WarehouseSnapshot>(config)
    .then(response => {
      return response.data;
    });
};
